export default "__VITE_ASSET__DADTfB2d__"